import type { AxiosResponse } from 'axios';

const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
export const downloadResponse = (response: AxiosResponse, fileNameOverride?: string) => {
  const disposition = response.headers['content-disposition'];
  const filenameMatch = filenameRegex.exec(disposition);
  const filename = fileNameOverride
    ? fileNameOverride
    : filenameMatch != null && filenameMatch[1]
    ? filenameMatch[1].replace(/['"]/g, '')
    : 'download';
  const url = window.URL.createObjectURL(new Blob([response.data], { type: response.headers['content-type'] }));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();
};
